import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';
import { apiWrapper } from '../../api/apiWrapper';

export const thunks = {
  getStates: createThunk('general/getStates', () =>
    api.get(WEB_API_ROUTES.general.getStates)
  ),

  getCities: createThunk('general/getCities', () =>
    api.get(WEB_API_ROUTES.general.getCities)
  ),

  getTimezones: createThunk('general/getTimezones', () =>
    api.get(WEB_API_ROUTES.general.getTimezones)
  ),

  getRooms: createThunk('general/getRooms', () =>
    api.get(WEB_API_ROUTES.general.rooms)
  ),

  getTeachers: createThunk('general/getTeachers', () =>
    api.get(WEB_API_ROUTES.general.teachers)
  ),

  getTeachersByRoutine: createThunk('general/getTeachersByRoutine', () =>
    api.get(WEB_API_ROUTES.general.routineTeachers)
  ),

  getUsers: createThunk('general/getUsers', () =>
    api.get(WEB_API_ROUTES.general.users)
  ),

  search: createThunk('general/search', ({ query, category }) =>
    api.get(WEB_API_ROUTES.general.search, { params: { query, category } })
  ),

  getProfile: createThunk('general/getProfile', () =>
    apiWrapper.get(WEB_API_ROUTES.general.profile)
  ),

  getStudio: createThunk('general/getStudio', ({ studioId }) =>
    api.get(WEB_API_ROUTES.general.studio.replace('{studioId}', studioId))
  ),

  updateStudio: createThunk(
    'general/updateStudio',
    async ({ studioId, data }) => {
      return api.put(
        WEB_API_ROUTES.general.studio.replace('{studioId}', studioId),
        data
      );
    }
  ),

  uploadStudioAvatar: createThunk(
    'settings/uploadAvatar',
    ({ studioId, data }) =>
      api.post(
        WEB_API_ROUTES.settings.uploadStudioAvatar.replace(
          '{studioId}',
          studioId
        ),
        data
      )
  ),

  removeStudioAvatar: createThunk('settings/removeStudioAvatar', (studioId) =>
    api.delete(
      WEB_API_ROUTES.settings.removeStudioImg.replace('{studioId}', studioId)
    )
  ),

  getRecipientsList: createThunk('general/getRecipientsList', () =>
    api.get(WEB_API_ROUTES.notifications.recipientsList)
  ),

  sendEmail: createThunk('general/sendEmail', (data) =>
    api.post(WEB_API_ROUTES.notifications.sendEmail, data)
  ),

  sendSms: createThunk('general/sendSms', (data) =>
    api.post(WEB_API_ROUTES.notifications.sendSms, data)
  ),

  getStudents: createThunk('general/getStudents', () =>
    api.get(WEB_API_ROUTES.general.students)
  ),

  getRoutineStatuses: createThunk('general/getRoutineStatuses', () =>
    api.get(WEB_API_ROUTES.general.routineStatuses)
  ),

  getStyles: createThunk('general/getStyles', () =>
    api.get(WEB_API_ROUTES.general.styles)
  ),

  getRoutineTypes: createThunk('general/getRoutineTypes', () =>
    api.get(WEB_API_ROUTES.general.routineTypes)
  ),

  getRoutineLevels: createThunk('general/getRoutineLevels', () =>
    api.get(WEB_API_ROUTES.general.routineLevels)
  ),

  getTags: createThunk('general/getTags', (data) =>
    api.get(WEB_API_ROUTES.general.tags, data)
  ),

  getNicknames: createThunk('general/getNicknames', (data) =>
    api.get(WEB_API_ROUTES.general.nicknames, data)
  ),

  getTagsAndNicknames: createThunk(
    'general/getTagsAndNicknames',
    ({ category, query }) =>
      api.get(WEB_API_ROUTES.general.getTagsAndNicknames, {
        params: { category, query },
      })
  ),

  sendNotificationReply: createThunk('general/sendNotificationReply', (data) =>
    api.post(WEB_API_ROUTES.notifications.reply, data)
  ),
};
